export default __webpack_public_path__ + "static/media/small_chart_clear.7db05fc5.png";